import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';
import { FileUploadStatus } from '../../uploader.interface';

@Component({
  selector: 'glxy-uploader-file-status',
  templateUrl: './uploader-file-status.component.html',
  styleUrls: ['./uploader-file-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GalaxyUploaderFileStatusComponent {
  @HostBinding('class') class = 'glxy-uploader-file-status';

  @Input() status?: FileUploadStatus;

  FileUploadStatus = FileUploadStatus;
}
